<template>
	<div class="footer">
        <div class="rule">
            <p>Copyright©2013-2017,dingfangyi.com.All rights reserved.<a href="http://beian.miit.gov.cn" class="rule-a" target="_blank">粤ICP备17131089号</a>   粤公网安备 44030302000423号</p>
        </div>
        <div class="suspension-box">
        	<div class="back-top" @click="toTop">
        		<i class="iconfont icon-xiala"></i>
        	</div>
            <div class="sus-item" @mouseover="qrShow1=true" @mouseout="qrShow1=false" >
                <i class="iconfont icon-erweima"></i>
                <div>预定客服1</div>
                <div v-show="qrShow1" class="item-prop" style="height: 250px;padding: 10px;">
                    <img src="../assets/img/qr1.png" alt="">
                    <div style="font-size:14px;">使用微信"扫一扫"</div>
                </div>
            </div>
            <div class="sus-item" @mouseover="qrShow2=true" @mouseout="qrShow2=false" >
                <i class="iconfont icon-erweima"></i>
                <div>预定客服2</div>
                <div v-show="qrShow2" class="item-prop" style="height: 250px;padding: 10px;">
                    <img src="../assets/img/qr2.png" alt="">
                    <div style="font-size:14px;">使用微信"扫一扫"</div>
                    
                </div>
            </div>
            <div class="sus-item" @mouseover="qrShow3=true" @mouseout="qrShow3=false" >
                <i class="iconfont icon-erweima"></i>
                <div>预定客服3</div>
                <div v-show="qrShow3" class="item-prop" style="height: 250px;padding: 10px;">
                    <img src="../assets/img/qr3.png" alt="">
                    <div style="font-size:14px;">使用微信"扫一扫"</div>
                </div>
			</div>
            <div class="sus-item" @mouseover="phoneShow2=true" @mouseout="phoneShow2=false" >
                <i class="iconfont icon-kefu"></i>
                <div>预订电话</div>
                <div v-show="phoneShow2" class="item-prop">0755-8236 3388</div>
            </div>
			<div class="sus-item" @mouseover="phoneShow1=true" @mouseout="phoneShow1=false" >
				<i class="iconfont icon-kefu"></i>
				<div>售后电话</div>
				<div v-show="phoneShow1" class="item-prop">010-5630 4887</div>
			</div>
        </div>
    </div>
</template>
<script>
export default {
	data() {
		return {
			phoneShow2: false,
			phoneShow1: false,
            qrShow1:false,
            qrShow2:false,
            qrShow3:false,
		}
	},
	methods: {
		toTop(){
			document.body.scrollTop = document.documentElement.scrollTop = 0;
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue